import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import tmdbApi from "../api/tmdbApi";
import Modal from 'react-bootstrap/Modal';
import moment from "moment";
import axios from "axios";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
let { lambda, appname } = window.app;
const FileViewer = (props) => {
    const docs = [
        { uri: props.source, fileType: props.type, fileName: props.name }  // Local File
    ];

    console.log('docs', docs);
    const clientActivity = (title, name) => {
        console.log('titletitletitletitletitle', title)
        let path = window.location.pathname.split("/");
        const token = localStorage.getItem("token")
        const clientId = localStorage.getItem("clientid")
        // const pageName = path[path.length - 2];
        var presentTime = moment();
        console.log('info.titleinfo.titleinfo.title', title)
        let payload;
        payload = {
            "activity": {
                pageVisited: props.title,
                action: "Downloaded file",
                time: moment().format("hh:mm A"),
                actionDescription: props.name,
                icon: "info"
            }
        }
        let urlLink;
        if (localStorage.getItem("previousid")) {
            urlLink = lambda + '/activity?appname=' + appname + "&previousid=" + localStorage.getItem("previousid") + "&token=" + token
        } else {
            urlLink = lambda + '/activity?appname=' + appname + "&token=" + token
        }

        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response.data.statusCode === 200) {
                    localStorage.setItem("previousid", response.data.result)
                }
            });
    }

    const handleClick = () => {
        clientActivity()
    }
    return (
        <>

            <Modal show={true} className="video-popup document-popup">
                <button className="close-btn" onClick={(e) => props.close(false)}>
                    <span className="material-icons">close</span>
                </button>
                <Modal.Body>
                    <div style={{ width: '100%', height: '90vh', position: 'relative' }}>
                        <DocViewer
                            style={{ width: '100%', height: '100%' }}
                            pluginRenderers={DocViewerRenderers}
                            documents={docs}
                        />
                        <a
                            className='document-btn'
                            href={props.source} // Replace with the actual URL of your Excel file
                            download={props.type} // Specify the desired filename for download
                            onClick={handleClick}
                            style={{
                                position: 'absolute',
                                bottom: '20px',
                                right: '20px',
                                backgroundColor: 'blue',
                                color: 'white',
                                padding: '10px 20px',
                                textDecoration: 'none',
                                borderRadius: '5px',
                            }}
                        >
                            Download
                        </a>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    );
};


export default FileViewer;



